<template>
    <div class="my-3">
        <div class="b-white p-3 rounded shadow-sm">
            <i class="fas fa-user-friends"></i> 
            Candidatos disponibles: 
            {{ candidates_to_use }}
        </div>
        <p class="font-gray-dark text-justify mt-3">
            <i class="fas fa-info-circle"></i> Al precionar sobre <i>Adquirir candidato</i> estaremos descontando candidatos a tu membresía actual. <br>
            Podras ver reflejada la información oculta para ponerte en contacto con tu candidato.
        </p>
        <b-button class="b-green btn-block mt-3 shadow-sm" @click="addCandidate">
            <i class="fas fa-receipt"></i> Adquirir candidato
        </b-button>
    </div>
</template>
<script>
export default {
    props:{
        candidates_to_use: Number
    },
    data() {
        return {
            
        }
    },
    methods: {
        addCandidate(){
           
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/#pages/candidates_gold/components/ContactCandidate.vue